import { memo, useCallback, useState, useEffect } from "react";
import { useModals } from "@mantine/modals";
import { useParams } from "react-router-dom";
import ActionCard from "src/components/ActionCard";
import { GetAgreementQuery } from "src/generated/graphql";
import RecurringChargeDetail from "../RecurringChargeDetail";
import { Sx } from "@mantine/core";
import { CardRadius, HeightCard } from "src/utils/constants";

export interface IRecurringCharges {
  recurringCharges: NonNullable<
    GetAgreementQuery["agreementOne"]
  >["recurringCharges"];
  sx?: Sx | (Sx | undefined)[] | undefined;
  disabled?: boolean;
  isAllowWrite: boolean;
}

function RecurringChargeList({
  recurringCharges,
  sx,
  disabled,
  isAllowWrite,
}: IRecurringCharges) {
  const modals = useModals();
  const { agreementId } = useParams<{ agreementId: string }>();

  const handleModal = useCallback(
    (recurringCharge = null) => {
      agreementId &&
        modals.openModal({
          closeOnClickOutside: false,
          title: `${recurringCharge ? "Update" : "Create"} Recurring Charge`,
          children: (
            <RecurringChargeDetail
              agreementId={agreementId}
              recurringCharge={recurringCharge}
              isModal={true}
              isAllowWrite={isAllowWrite}
            />
          ),
        });
    },
    [agreementId, isAllowWrite]
  );

  return (
    <ActionCard
      title={"Recurring"}
      radius={CardRadius.xs}
      height={HeightCard.xs}
      size="md"
      handleModal={disabled || !isAllowWrite ? undefined : () => handleModal()}
      sx={sx}
    >
      {recurringCharges?.map((e) => (
        <RecurringChargeDetail
          agreementId={agreementId!}
          key={e.id}
          recurringCharge={e}
          handleModal={handleModal}
          disabled={disabled}
          isAllowWrite={isAllowWrite}
        />
      ))}
    </ActionCard>
  );
}

export default memo(RecurringChargeList);
